export default __webpack_public_path__ + "static/media/Spin-1s-200px.d32a2fd4.gif";